/*
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-11-16 15:26:03
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-03-25 17:32:26
 * @FilePath: \miniproweb\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/*
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-11-16 15:26:03
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2023-11-16 15:34:26
 * @FilePath: \miniproweb\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import WarningCus from '../views/WarningCus'
import Popularization from '../views/Popularization'
import Popularization2 from '../views/Popularization2'
import Radar from '../views/Radar'
import PushCustom from '../views/PushCustom'
import RiceData from '../views/RiceData'
import WheatData from '../views/WheatData'
import OilseedData from '../views/OilseedData'
import DocPage from '../views/DocPage'
import DocPage2 from '../views/DocPage2'
import EarlyWarning from '../views/EarlyWarning'
import WeatherForecast from '../views/WeatherForecast'
import StationInfo from '../views/StationInfo'
import QueryStatistics from '../views/QueryStatistics'
import Echart from '../views/Echart'
import UserMsg from '../views/UserMsg'
import ShowPdf from '../views/ShowPdf'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'WarningCus',
    component: WarningCus
  },
  {
    path: '/Popularization',
    name: 'Popularization',
    component: Popularization
  },
  {
    path: '/ShowPdf',
    name: 'ShowPdf',
    component: ShowPdf
  },
  {
    path: '/Echart',
    name: 'Echart',
    component: Echart
  },
  {
    path: '/Popularization2',
    name: 'Popularization2',
    component: Popularization2
  },
  {
    path: '/Radar',
    name: 'Radar',
    component: Radar
  },
  {
    path: '/PushCustom',
    name: 'PushCustom',
    component: PushCustom
  },
  {
    path: '/RiceData',
    name: 'RiceData',
    component: RiceData
  },
  {
    path: '/WheatData',
    name: 'WheatData',
    component: WheatData
  },
  {
    path: '/OilseedData',
    name: 'OilseedData',
    component: OilseedData
  },
  {
    path: '/DocPage/:id',
    name: 'DocPage',
    component: DocPage
  },
  {
    path: '/DocPage2/:id',
    name: 'DocPage2',
    component: DocPage2
  },
  {
    path: '/EarlyWarning',
    name: 'EarlyWarning',
    component: EarlyWarning
  },
  {
    path: '/WeatherForecast',
    name: 'WeatherForecast',
    component: WeatherForecast
  },
  {
    path: '/StationInfo',
    name: 'StationInfo',
    component: StationInfo
  },
  {
    path: '/QueryStatistics',
    name: 'QueryStatistics',
    component: QueryStatistics
  },
  {
    path: '/UserMsg',
    name: 'UserMsg',
    component: UserMsg
  },

]

const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  // base: '/miniproweb',
  routes
})

export default router
